import React from "react";
import { Box } from "@mui/material";
import Header from "../Home/Header";
import BannerSection from "../Home/BannerSection";
import ServicesSection from "../Home/ServicesSection";
import BBPSSection from "../Home/BBPSSection";
import AllServices from "../Home/AllServices";
import Footer from "../Home/Footer";

export default function Layout() {
  return (
    <Box sx={{ bgcolor: "white", overflowX: "hidden" }}>
      <Header />
      <BannerSection />
      <ServicesSection />
      <BBPSSection />
      <AllServices />
      <Footer />
    </Box>
  );
}
